export const countries = {
  en: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "The Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo, Democratic Republic of the",
    "Congo, Republic of the",
    "Costa Rica",
    "Côte d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor (Timor-Leste)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "The Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia, Federated States of",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Sudan, South",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ],
  // Adicionar traduções conforme necessário
};

export const studyLevels = ["subject_primary", "subject_highschool", "subject_vocational", "subject_bachelor", "subject_master", "subject_doctorate"];

export const subjects = ["subject_fuel_pumps", "subject_ev", "subject_hydrogen", "subject_payments", "subject_wetstock", "subject_car_wash", "subject_others"];

export const countries_c4c = {
  "en": {
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Åland Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Democratic Republic of the Congo",
    "CF": "Central African Republic",
    "CG": "Congo",
    "CH": "Switzerland",
    "CI": "Ivory Coast",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curaçao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Heard Island and McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macau",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn Islands",
    "PR": "Puerto Rico",
    "PS": "State of Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "São Tomé and Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Eswatini",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern and Antarctic Lands",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "United States Minor Outlying Islands",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Vatican City",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  },
    "pt": {
      "AD": "Andorra",
      "AE": "Emirados Árabes Unidos",
      "AF": "Afeganistão",
      "AG": "Antígua e Barbuda",
      "AI": "Anguilla",
      "AL": "Albânia",
      "AM": "Arménia",
      "AO": "Angola",
      "AQ": "Antártida",
      "AR": "Argentina",
      "AS": "Samoa Americana",
      "AT": "Áustria",
      "AU": "Austrália",
      "AW": "Aruba",
      "AX": "Ilhas Åland",
      "AZ": "Azerbaijão",
      "BA": "Bósnia e Herzegovina",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Bélgica",
      "BF": "Burquina Faso",
      "BG": "Bulgária",
      "BH": "Barém",
      "BI": "Burundi",
      "BJ": "Benim",
      "BL": "São Bartolomeu",
      "BM": "Bermudas",
      "BN": "Brunei Darussalam",
      "BO": "Bolívia",
      "BQ": "Bonaire, Santo Eustáquio e Saba",
      "BR": "Brasil",
      "BS": "Bahamas",
      "BT": "Butão",
      "BV": "Ilha Bouvet",
      "BW": "Botsuana",
      "BY": "Bielorrússia",
      "BZ": "Belize",
      "CA": "Canadá",
      "CC": "Ilhas Cocos (Keeling)",
      "CD": "República Democrática do Congo",
      "CF": "República Centro-Africana",
      "CG": "Congo",
      "CH": "Suíça",
      "CI": "Costa do Marfim",
      "CK": "Ilhas Cook",
      "CL": "Chile",
      "CM": "Camarões",
      "CN": "China",
      "CO": "Colômbia",
      "CR": "Costa Rica",
      "CU": "Cuba",
      "CV": "Cabo Verde",
      "CW": "Curaçao",
      "CX": "Ilha Christmas",
      "CY": "Chipre",
      "CZ": "República Checa",
      "DE": "Alemanha",
      "DJ": "Djibuti",
      "DK": "Dinamarca",
      "DM": "Dominica",
      "DO": "República Dominicana",
      "DZ": "Argélia",
      "EC": "Equador",
      "EE": "Estónia",
      "EG": "Egito",
      "EH": "Saara Ocidental",
      "ER": "Eritreia",
      "ES": "Espanha",
      "ET": "Etiópia",
      "FI": "Finlândia",
      "FJ": "Fiji",
      "FK": "Ilhas Malvinas",
      "FM": "Micronésia",
      "FO": "Ilhas Faroé",
      "FR": "França",
      "GA": "Gabão",
      "GB": "Reino Unido",
      "GD": "Granada",
      "GE": "Geórgia",
      "GF": "Guiana Francesa",
      "GG": "Guernsey",
      "GH": "Gana",
      "GI": "Gibraltar",
      "GL": "Gronelândia",
      "GM": "Gâmbia",
      "GN": "Guiné",
      "GP": "Guadalupe",
      "GQ": "Guiné Equatorial",
      "GR": "Grécia",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guiné-Bissau",
      "GY": "Guiana",
      "HK": "Hong Kong",
      "HM": "Ilhas Heard e McDonald",
      "HN": "Honduras",
      "HR": "Croácia",
      "HT": "Haiti",
      "HU": "Hungria",
      "ID": "Indonésia",
      "IE": "Irlanda",
      "IL": "Israel",
      "IM": "Ilha de Man",
      "IN": "Índia",
      "IO": "Território Britânico do Oceano Índico",
      "IQ": "Iraque",
      "IR": "Irão",
      "IS": "Islândia",
      "IT": "Itália",
      "JE": "Jersey",
      "JM": "Jamaica",
      "JO": "Jordânia",
      "JP": "Japão",
      "KE": "Quénia",
      "KG": "Quirguistão",
      "KH": "Camboja",
      "KI": "Quiribáti",
      "KM": "Comores",
      "KN": "São Cristóvão e Nevis",
      "KP": "Coreia do Norte",
      "KR": "Coreia do Sul",
      "KW": "Kuwait",
      "KY": "Ilhas Caimão",
      "KZ": "Cazaquistão",
      "LA": "Laos",
      "LB": "Líbano",
      "LC": "Santa Lúcia",
      "LI": "Listenstaine",
      "LK": "Sri Lanka",
      "LR": "Libéria",
      "LS": "Lesoto",
      "LT": "Lituânia",
      "LU": "Luxemburgo",
      "LV": "Letónia",
      "LY": "Líbia",
      "MA": "Marrocos",
      "MC": "Mónaco",
      "MD": "Moldávia",
      "ME": "Montenegro",
      "MF": "São Martinho",
      "MG": "Madagáscar",
      "MH": "Ilhas Marshall",
      "MK": "Macedónia do Norte",
      "ML": "Mali",
      "MM": "Mianmar",
      "MN": "Mongólia",
      "MO": "Macau",
      "MP": "Ilhas Marianas do Norte",
      "MQ": "Martinica",
      "MR": "Mauritânia",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Maurícia",
      "MV": "Maldivas",
      "MW": "Maláui",
      "MX": "México",
      "MY": "Malásia",
      "MZ": "Moçambique",
      "NA": "Namíbia",
      "NC": "Nova Caledónia",
      "NE": "Níger",
      "NF": "Ilha Norfolk",
      "NG": "Nigéria",
      "NI": "Nicarágua",
      "NL": "Países Baixos",
      "NO": "Noruega",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "Nova Zelândia",
      "OM": "Omã",
      "PA": "Panamá",
      "PE": "Peru",
      "PF": "Polinésia Francesa",
      "PG": "Papua-Nova Guiné",
      "PH": "Filipinas",
      "PK": "Paquistão",
      "PL": "Polónia",
      "PM": "São Pedro e Miquelão",
      "PN": "Ilhas Pitcairn",
      "PR": "Porto Rico",
      "PS": "Estado da Palestina",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguai",
      "QA": "Catar",
      "RE": "Reunião",
      "RO": "Roménia",
      "RS": "Sérvia",
      "RU": "Rússia",
      "RW": "Ruanda",
      "SA": "Arábia Saudita",
      "SB": "Ilhas Salomão",
      "SC": "Seicheles",
      "SD": "Sudão",
      "SE": "Suécia",
      "SG": "Singapura",
      "SH": "Santa Helena",
      "SI": "Eslovénia",
      "SJ": "Svalbard e Jan Mayen",
      "SK": "Eslováquia",
      "SL": "Serra Leoa",
      "SM": "São Marino",
      "SN": "Senegal",
      "SO": "Somália",
      "SR": "Suriname",
      "SS": "Sudão do Sul",
      "ST": "São Tomé e Príncipe",
      "SV": "El Salvador",
      "SX": "Sint Maarten",
      "SY": "Síria",
      "SZ": "Essuatíni",
      "TC": "Ilhas Turks e Caicos",
      "TD": "Chade",
      "TF": "Territórios Franceses do Sul",
      "TG": "Togo",
      "TH": "Tailândia",
      "TJ": "Tajiquistão",
      "TK": "Toquelau",
      "TL": "Timor-Leste",
      "TM": "Turquemenistão",
      "TN": "Tunísia",
      "TO": "Tonga",
      "TR": "Turquia",
      "TT": "Trindade e Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzânia",
      "UA": "Ucrânia",
      "UG": "Uganda",
      "UM": "Ilhas Menores Distantes dos EUA",
      "US": "Estados Unidos",
      "UY": "Uruguai",
      "UZ": "Uzbequistão",
      "VA": "Cidade do Vaticano",
      "VC": "São Vicente e Granadinas",
      "VE": "Venezuela",
      "VG": "Ilhas Virgens Britânicas",
      "VI": "Ilhas Virgens dos EUA",
      "VN": "Vietname",
      "VU": "Vanuatu",
      "WF": "Wallis e Futuna",
      "WS": "Samoa",
      "YE": "Iémen",
      "YT": "Mayotte",
      "ZA": "África do Sul",
      "ZM": "Zâmbia",
      "ZW": "Zimbabué"
    },
  "fr": {
    "AD": "Andorre",
    "AE": "Émirats Arabes Unis",
    "AF": "Afghanistan",
    "AG": "Antigua-et-Barbuda",
    "AI": "Anguilla",
    "AL": "Albanie",
    "AM": "Arménie",
    "AO": "Angola",
    "AQ": "Antarctique",
    "AR": "Argentine",
    "AS": "Samoa américaines",
    "AT": "Autriche",
    "AU": "Australie",
    "AW": "Aruba",
    "AX": "Îles Åland",
    "AZ": "Azerbaïdjan",
    "BA": "Bosnie-Herzégovine",
    "BB": "Barbade",
    "BD": "Bangladesh",
    "BE": "Belgique",
    "BF": "Burkina Faso",
    "BG": "Bulgarie",
    "BH": "Bahreïn",
    "BI": "Burundi",
    "BJ": "Bénin",
    "BL": "Saint-Barthélemy",
    "BM": "Bermudes",
    "BN": "Brunei",
    "BO": "Bolivie",
    "BQ": "Bonaire, Saint-Eustache et Saba",
    "BR": "Brésil",
    "BS": "Bahamas",
    "BT": "Bhoutan",
    "BV": "Île Bouvet",
    "BW": "Botswana",
    "BY": "Bélarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Îles Cocos (Keeling)",
    "CD": "République Démocratique du Congo",
    "CF": "République Centrafricaine",
    "CG": "Congo",
    "CH": "Suisse",
    "CI": "Côte d'Ivoire",
    "CK": "Îles Cook",
    "CL": "Chili",
    "CM": "Cameroun",
    "CN": "Chine",
    "CO": "Colombie",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cap-Vert",
    "CW": "Curaçao",
    "CX": "Île Christmas",
    "CY": "Chypre",
    "CZ": "République tchèque",
    "DE": "Allemagne",
    "DJ": "Djibouti",
    "DK": "Danemark",
    "DM": "Dominique",
    "DO": "République dominicaine",
    "DZ": "Algérie",
    "EC": "Équateur",
    "EE": "Estonie",
    "EG": "Égypte",
    "EH": "Sahara occidental",
    "ER": "Érythrée",
    "ES": "Espagne",
    "ET": "Éthiopie",
    "FI": "Finlande",
    "FJ": "Fidji",
    "FK": "Îles Malouines",
    "FM": "Micronésie",
    "FO": "Îles Féroé",
    "FR": "France",
    "GA": "Gabon",
    "GB": "Royaume-Uni",
    "GD": "Grenade",
    "GE": "Géorgie",
    "GF": "Guyane française",
    "GG": "Guernesey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenland",
    "GM": "Gambie",
    "GN": "Guinée",
    "GP": "Guadeloupe",
    "GQ": "Guinée équatoriale",
    "GR": "Grèce",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinée-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Îles Heard et McDonald",
    "HN": "Honduras",
    "HR": "Croatie",
    "HT": "Haïti",
    "HU": "Hongrie",
    "ID": "Indonésie",
    "IE": "Irlande",
    "IL": "Israël",
    "IM": "Île de Man",
    "IN": "Inde",
    "IO": "Territoire britannique de l'océan Indien",
    "IQ": "Irak",
    "IR": "Iran",
    "IS": "Islande",
    "IT": "Italie",
    "JE": "Jersey",
    "JM": "Jamaïque",
    "JO": "Jordanie",
    "JP": "Japon",
    "KE": "Kenya",
    "KG": "Kirghizistan",
    "KH": "Cambodge",
    "KI": "Kiribati",
    "KM": "Comores",
    "KN": "Saint-Christophe-et-Niévès",
    "KP": "Corée du Nord",
    "KR": "Corée du Sud",
    "KW": "Koweït",
    "KY": "Îles Caïmans",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Liban",
    "LC": "Sainte-Lucie",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Libéria",
    "LS": "Lesotho",
    "LT": "Lituanie",
    "LU": "Luxembourg",
    "LV": "Lettonie",
    "LY": "Libye",
    "MA": "Maroc",
    "MC": "Monaco",
    "MD": "Moldavie",
    "ME": "Monténégro",
    "MF": "Saint-Martin",
    "MG": "Madagascar",
    "MH": "Îles Marshall",
    "MK": "Macédoine du Nord",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolie",
    "MO": "Macao",
    "MP": "Îles Mariannes du Nord",
    "MQ": "Martinique",
    "MR": "Mauritanie",
    "MS": "Montserrat",
    "MT": "Malte",
    "MU": "Maurice",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexique",
    "MY": "Malaisie",
    "MZ": "Mozambique",
    "NA": "Namibie",
    "NC": "Nouvelle-Calédonie",
    "NE": "Niger",
    "NF": "Île Norfolk",
    "NG": "Nigéria",
    "NI": "Nicaragua",
    "NL": "Pays-Bas",
    "NO": "Norvège",
    "NP": "Népal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nouvelle-Zélande",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Pérou",
    "PF": "Polynésie française",
    "PG": "Papouasie-Nouvelle-Guinée",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Pologne",
    "PM": "Saint-Pierre-et-Miquelon",
    "PN": "Îles Pitcairn",
    "PR": "Porto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palaos",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Roumanie",
    "RS": "Serbie",
    "RU": "Russie",
    "RW": "Rwanda",
    "SA": "Arabie Saoudite",
    "SB": "Îles Salomon",
    "SC": "Seychelles",
    "SD": "Soudan",
    "SE": "Suède",
    "SG": "Singapour",
    "SH": "Sainte-Hélène",
    "SI": "Slovénie",
    "SJ": "Svalbard et Jan Mayen",
    "SK": "Slovaquie",
    "SL": "Sierra Leone",
    "SM": "Saint-Marin",
    "SN": "Sénégal",
    "SO": "Somalie",
    "SR": "Suriname",
    "SS": "Soudan du Sud",
    "ST": "Sao Tomé-et-Principe",
    "SV": "Salvador",
    "SX": "Saint-Martin (partie néerlandaise)",
    "SY": "Syrie",
    "SZ": "Eswatini",
    "TC": "Îles Turques-et-Caïques",
    "TD": "Tchad",
    "TF": "Terres australes et antarctiques françaises",
    "TG": "Togo",
    "TH": "Thaïlande",
    "TJ": "Tadjikistan",
    "TK": "Tokélaou",
    "TL": "Timor oriental",
    "TM": "Turkménistan",
    "TN": "Tunisie",
    "TO": "Tonga",
    "TR": "Turquie",
    "TT": "Trinité-et-Tobago",
    "TV": "Tuvalu",
    "TW": "Taïwan",
    "TZ": "Tanzanie",
    "UA": "Ukraine",
    "UG": "Ouganda",
    "UM": "Îles mineures éloignées des États-Unis",
    "US": "États-Unis",
    "UY": "Uruguay",
    "UZ": "Ouzbékistan",
    "VA": "Vatican",
    "VC": "Saint-Vincent-et-les-Grenadines",
    "VE": "Venezuela",
    "VG": "Îles Vierges britanniques",
    "VI": "Îles Vierges des États-Unis",
    "VN": "Viêt Nam",
    "VU": "Vanuatu",
    "WF": "Wallis-et-Futuna",
    "WS": "Samoa",
    "YE": "Yémen",
    "YT": "Mayotte",
    "ZA": "Afrique du Sud",
    "ZM": "Zambie",
    "ZW": "Zimbabwe"
  },
  "de": {
    "AD": "Andorra",
    "AE": "Vereinigte Arabische Emirate",
    "AF": "Afghanistan",
    "AG": "Antigua und Barbuda",
    "AI": "Anguilla",
    "AL": "Albanien",
    "AM": "Armenien",
    "AO": "Angola",
    "AQ": "Antarktis",
    "AR": "Argentinien",
    "AS": "Amerikanisch-Samoa",
    "AT": "Österreich",
    "AU": "Australien",
    "AW": "Aruba",
    "AX": "Ålandinseln",
    "AZ": "Aserbaidschan",
    "BA": "Bosnien und Herzegowina",
    "BB": "Barbados",
    "BD": "Bangladesch",
    "BE": "Belgien",
    "BF": "Burkina Faso",
    "BG": "Bulgarien",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint-Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivien",
    "BQ": "Bonaire, Sint Eustatius und Saba",
    "BR": "Brasilien",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvetinsel",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Kanada",
    "CC": "Kokosinseln",
    "CD": "Demokratische Republik Kongo",
    "CF": "Zentralafrikanische Republik",
    "CG": "Republik Kongo",
    "CH": "Schweiz",
    "CI": "Elfenbeinküste",
    "CK": "Cookinseln",
    "CL": "Chile",
    "CM": "Kamerun",
    "CN": "China",
    "CO": "Kolumbien",
    "CR": "Costa Rica",
    "CU": "Kuba",
    "CV": "Kap Verde",
    "CW": "Curaçao",
    "CX": "Weihnachtsinsel",
    "CY": "Zypern",
    "CZ": "Tschechische Republik",
    "DE": "Deutschland",
    "DJ": "Dschibuti",
    "DK": "Dänemark",
    "DM": "Dominica",
    "DO": "Dominikanische Republik",
    "DZ": "Algerien",
    "EC": "Ecuador",
    "EE": "Estland",
    "EG": "Ägypten",
    "EH": "Westsahara",
    "ER": "Eritrea",
    "ES": "Spanien",
    "ET": "Äthiopien",
    "FI": "Finnland",
    "FJ": "Fidschi",
    "FK": "Falklandinseln",
    "FM": "Mikronesien",
    "FO": "Färöer-Inseln",
    "FR": "Frankreich",
    "GA": "Gabun",
    "GB": "Vereinigtes Königreich",
    "GD": "Grenada",
    "GE": "Georgien",
    "GF": "Französisch-Guayana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Grönland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Äquatorialguinea",
    "GR": "Griechenland",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hongkong",
    "HM": "Heard und McDonaldinseln",
    "HN": "Honduras",
    "HR": "Kroatien",
    "HT": "Haiti",
    "HU": "Ungarn",
    "ID": "Indonesien",
    "IE": "Irland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "Indien",
    "IO": "Britisches Territorium im Indischen Ozean",
    "IQ": "Irak",
    "IR": "Iran",
    "IS": "Island",
    "IT": "Italien",
    "JE": "Jersey",
    "JM": "Jamaika",
    "JO": "Jordanien",
    "JP": "Japan",
    "KE": "Kenia",
    "KG": "Kirgisistan",
    "KH": "Kambodscha",
    "KI": "Kiribati",
    "KM": "Komoren",
    "KN": "St. Kitts und Nevis",
    "KP": "Nordkorea",
    "KR": "Südkorea",
    "KW": "Kuwait",
    "KY": "Kaimaninseln",
    "KZ": "Kasachstan",
    "LA": "Laos",
    "LB": "Libanon",
    "LC": "St. Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Litauen",
    "LU": "Luxemburg",
    "LV": "Lettland",
    "LY": "Libyen",
    "MA": "Marokko",
    "MC": "Monaco",
    "MD": "Moldawien",
    "ME": "Montenegro",
    "MF": "Saint-Martin",
    "MG": "Madagaskar",
    "MH": "Marshallinseln",
    "MK": "Nordmazedonien",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolei",
    "MO": "Macau",
    "MP": "Nördliche Marianen",
    "MQ": "Martinique",
    "MR": "Mauretanien",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Malediven",
    "MW": "Malawi",
    "MX": "Mexiko",
    "MY": "Malaysia",
    "MZ": "Mosambik",
    "NA": "Namibia",
    "NC": "Neukaledonien",
    "NE": "Niger",
    "NF": "Norfolkinsel",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Niederlande",
    "NO": "Norwegen",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Neuseeland",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "Französisch-Polynesien",
    "PG": "Papua-Neuguinea",
    "PH": "Philippinen",
    "PK": "Pakistan",
    "PL": "Polen",
    "PM": "Saint-Pierre und Miquelon",
    "PN": "Pitcairninseln",
    "PR": "Puerto Rico",
    "PS": "Palästinensische Gebiete",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Katar",
    "RE": "Réunion",
    "RO": "Rumänien",
    "RS": "Serbien",
    "RU": "Russland",
    "RW": "Ruanda",
    "SA": "Saudi-Arabien",
    "SB": "Salomonen",
    "SC": "Seychellen",
    "SD": "Sudan",
    "SE": "Schweden",
    "SG": "Singapur",
    "SH": "St. Helena",
    "SI": "Slowenien",
    "SJ": "Svalbard und Jan Mayen",
    "SK": "Slowakei",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "Südsudan",
    "ST": "São Tomé und Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syrien",
    "SZ": "Eswatini",
    "TC": "Turks- und Caicosinseln",
    "TD": "Tschad",
    "TF": "Französische Süd- und Antarktisgebiete",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tadschikistan",
    "TK": "Tokelau",
    "TL": "Osttimor",
    "TM": "Turkmenistan",
    "TN": "Tunesien",
    "TO": "Tonga",
    "TR": "Türkei",
    "TT": "Trinidad und Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tansania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "Amerikanische Überseeinseln",
    "US": "Vereinigte Staaten",
    "UY": "Uruguay",
    "UZ": "Usbekistan",
    "VA": "Vatikanstadt",
    "VC": "St. Vincent und die Grenadinen",
    "VE": "Venezuela",
    "VG": "Britische Jungferninseln",
    "VI": "Amerikanische Jungferninseln",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis und Futuna",
    "WS": "Samoa",
    "YE": "Jemen",
    "YT": "Mayotte",
    "ZA": "Südafrika",
    "ZM": "Sambia",
    "ZW": "Simbabwe"
  },
  "es": {
    "AD": "Andorra",
    "AE": "Emiratos Árabes Unidos",
    "AF": "Afganistán",
    "AG": "Antigua y Barbuda",
    "AI": "Anguila",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antártida",
    "AR": "Argentina",
    "AS": "Samoa Americana",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Islas Åland",
    "AZ": "Azerbaiyán",
    "BA": "Bosnia y Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladés",
    "BE": "Bélgica",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Baréin",
    "BI": "Burundi",
    "BJ": "Benín",
    "BL": "San Bartolomé",
    "BM": "Bermudas",
    "BN": "Brunéi",
    "BO": "Bolivia",
    "BQ": "Bonaire, San Eustaquio y Saba",
    "BR": "Brasil",
    "BS": "Bahamas",
    "BT": "Bután",
    "BV": "Isla Bouvet",
    "BW": "Botsuana",
    "BY": "Bielorrusia",
    "BZ": "Belice",
    "CA": "Canadá",
    "CC": "Islas Cocos (Keeling)",
    "CD": "República Democrática del Congo",
    "CF": "República Centroafricana",
    "CG": "Congo",
    "CH": "Suiza",
    "CI": "Costa de Marfil",
    "CK": "Islas Cook",
    "CL": "Chile",
    "CM": "Camerún",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cabo Verde",
    "CW": "Curazao",
    "CX": "Isla Christmas",
    "CY": "Chipre",
    "CZ": "República Checa",
    "DE": "Alemania",
    "DJ": "Yibuti",
    "DK": "Dinamarca",
    "DM": "Dominica",
    "DO": "República Dominicana",
    "DZ": "Argelia",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egipto",
    "EH": "Sahara Occidental",
    "ER": "Eritrea",
    "ES": "España",
    "ET": "Etiopía",
    "FI": "Finlandia",
    "FJ": "Fiyi",
    "FK": "Islas Malvinas",
    "FM": "Micronesia",
    "FO": "Islas Feroe",
    "FR": "Francia",
    "GA": "Gabón",
    "GB": "Reino Unido",
    "GD": "Granada",
    "GE": "Georgia",
    "GF": "Guayana Francesa",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenlandia",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadalupe",
    "GQ": "Guinea Ecuatorial",
    "GR": "Grecia",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bisáu",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Islas Heard y McDonald",
    "HN": "Honduras",
    "HR": "Croacia",
    "HT": "Haití",
    "HU": "Hungría",
    "ID": "Indonesia",
    "IE": "Irlanda",
    "IL": "Israel",
    "IM": "Isla de Man",
    "IN": "India",
    "IO": "Territorio Británico del Océano Índico",
    "IQ": "Irak",
    "IR": "Irán",
    "IS": "Islandia",
    "IT": "Italia",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordania",
    "JP": "Japón",
    "KE": "Kenia",
    "KG": "Kirguistán",
    "KH": "Camboya",
    "KI": "Kiribati",
    "KM": "Comoras",
    "KN": "San Cristóbal y Nieves",
    "KP": "Corea del Norte",
    "KR": "Corea del Sur",
    "KW": "Kuwait",
    "KY": "Islas Caimán",
    "KZ": "Kazajistán",
    "LA": "Laos",
    "LB": "Líbano",
    "LC": "Santa Lucía",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesoto",
    "LT": "Lituania",
    "LU": "Luxemburgo",
    "LV": "Letonia",
    "LY": "Libia",
    "MA": "Marruecos",
    "MC": "Mónaco",
    "MD": "Moldavia",
    "ME": "Montenegro",
    "MF": "San Martín",
    "MG": "Madagascar",
    "MH": "Islas Marshall",
    "MK": "Macedonia del Norte",
    "ML": "Malí",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macao",
    "MP": "Islas Marianas del Norte",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauricio",
    "MV": "Maldivas",
    "MW": "Malaui",
    "MX": "México",
    "MY": "Malasia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "Nueva Caledonia",
    "NE": "Níger",
    "NF": "Isla Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Países Bajos",
    "NO": "Noruega",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nueva Zelanda",
    "OM": "Omán",
    "PA": "Panamá",
    "PE": "Perú",
    "PF": "Polinesia Francesa",
    "PG": "Papúa Nueva Guinea",
    "PH": "Filipinas",
    "PK": "Pakistán",
    "PL": "Polonia",
    "PM": "San Pedro y Miquelón",
    "PN": "Islas Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Estado de Palestina",
    "PT": "Portugal",
    "PW": "Palaos",
    "PY": "Paraguay",
    "QA": "Catar",
    "RE": "Reunión",
    "RO": "Rumania",
    "RS": "Serbia",
    "RU": "Rusia",
    "RW": "Ruanda",
    "SA": "Arabia Saudita",
    "SB": "Islas Salomón",
    "SC": "Seychelles",
    "SD": "Sudán",
    "SE": "Suecia",
    "SG": "Singapur",
    "SH": "Santa Elena",
    "SI": "Eslovenia",
    "SJ": "Svalbard y Jan Mayen",
    "SK": "Eslovaquia",
    "SL": "Sierra Leona",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Surinam",
    "SS": "Sudán del Sur",
    "ST": "Santo Tomé y Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Siria",
    "SZ": "Esuatini",
    "TC": "Islas Turcas y Caicos",
    "TD": "Chad",
    "TF": "Tierras Australes y Antárticas Francesas",
    "TG": "Togo",
    "TH": "Tailandia",
    "TJ": "Tayikistán",
    "TK": "Tokelau",
    "TL": "Timor Oriental",
    "TM": "Turkmenistán",
    "TN": "Túnez",
    "TO": "Tonga",
    "TR": "Turquía",
    "TT": "Trinidad y Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwán",
    "TZ": "Tanzania",
    "UA": "Ucrania",
    "UG": "Uganda",
    "UM": "Islas Ultramarinas de EE. UU.",
    "US": "Estados Unidos",
    "UY": "Uruguay",
    "UZ": "Uzbekistán",
    "VA": "Ciudad del Vaticano",
    "VC": "San Vicente y las Granadinas",
    "VE": "Venezuela",
    "VG": "Islas Vírgenes Británicas",
    "VI": "Islas Vírgenes de los Estados Unidos",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis y Futuna",
    "WS": "Samoa",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "Sudáfrica",
    "ZM": "Zambia",
    "ZW": "Zimbabue"
  },
  "it": {
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Åland Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Democratic Republic of the Congo",
    "CF": "Central African Republic",
    "CG": "Congo",
    "CH": "Switzerland",
    "CI": "Ivory Coast",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curaçao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Heard Island and McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macau",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn Islands",
    "PR": "Puerto Rico",
    "PS": "State of Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "São Tomé and Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Eswatini",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern and Antarctic Lands",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "United States Minor Outlying Islands",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Vatican City",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  },

}

export const roles = {
  "pt": {
    "0028": "Consultor / Controlo de gestão",
    "0009": "CFO / Responsável financeiro",
    "Z002": "Chief Technology Officer",
    "0023": "Diretor de operações",
    "0002": "Diretor de Compras",
    "0024": "Engenheiro / Especialista Ops.",
    "0025": "Especialista de compras",
    "0001": "Gerente / Admin. / Direção exec.",
    "0013": "Gerente de serviço e suporte",
    "0010": "Diretor de marketing",
    "Z005": "Responsável pela Manutenção",
    "Z004": "Responsável de Loja",
    "0008": "Responsável TI",
    "Z003": "Técnico de Operações",
    "Z006": "Outro"
  },
  "es": {
    "0028": "Asesor / Analista ctrl.gestión",
    "0009": "CFO / Gerente financ.",
    "Z002": "Chief Technology Officer",
    "0023": "Director de operaciones",
    "0002": "Director de compras",
    "0010": "Director marketing",
    "0024": "Ingeniero / Especialista Op.",
    "0025": "Especialista en compras",
    "0001": "Administrador / Junta Directiva",
    "0013": "Gerente de servicio y soporte",
    "Z005": "Jefe de mantenimiento",
    "Z004": "Encargado de tienda",
    "0008": "Gerente de TI",
    "Z003": "Técnico de operaciones",
    "Z006": "Otro"
  },
  "en": {
    "0028": "Consultant/ Business Analyst",
    "0009": "CFO / Financial Manager",
    "Z002": "Chief Technology Officer",
    "0023": "Operations Director",
    "0002": "Purchasing Manager",
    "0025": "Purchase Specialist",
    "0001": "Admin. / Managing Board",
    "0010": "Marketing Manager",
    "0013": "Service Support Manager",
    "Z005": "Maintenence Manager",
    "0024": "Engineer / Ops. Specialist",
    "0008": "IT Manager",
    "Z004": "Store Manager",
    "Z003": "Operations Technician",
    "Z006": "Other"
  },
  "fr": {
    "0028": "Consultant / contrôle de gestion",
    "0009": "Directeur financier",
    "Z002": "Chief Technology Officer",
    "0023": "Directeur des opérations",
    "0002": "Directeur des achats",
    "0024": "Ingénieur/ Spécialiste Opér.",
    "0025": "Expert achats",
    "0001": "Administr. / Conseil d'adm.",
    "0013": "Responsable service et support",
    "0010": "Directeur marketing",
    "Z005": "Responsable de la maintenance",
    "Z004": "Responsable de magasin",
    "0008": "Responsable systèmes de TI",
    "Z003": "Technicien des opérations",
    "Z006": "Autres"
  },
  "de": {
    "0028": "Berater / Controlling",
    "0009": "Finanzdirektor",
    "Z002": "Technischer Leiter (CTO)",
    "0023": "Betriebsleiter",
    "0002": "Einkaufsleiter",
    "0025": "Einkaufsexperte",
    "0001": "Verwaltung / Aufsichtsrat",
    "0013": "Service- und Supportmanager",
    "0010": "Marketingdirektor",
    "Z005": "Instandhaltungsmanager",
    "0024": "Ingenieur / Betriebsspezialist",
    "0008": "IT-Systemmanager",
    "Z004": "Filialleiter",
    "Z003": "Betriebstechniker",
    "Z006": "Sonstige"
  },
  "it": {
    "0028": "Consulente / Contr. di gestione",
    "0009": "Direttore finanziario",
    "Z002": "Direttore tecnologico (CTO)",
    "0023": "Direttore delle operazioni",
    "0002": "Direttore acquisti",
    "0024": "Ingegnere / Special. operazioni",
    "0025": "Esperto acquisti",
    "0001": "Ammin. / Consig. amministrazione",
    "0013": "Respons. servizio e supporto",
    "0010": "Direttore marketing",
    "Z005": "Respons. della manutenzione",
    "Z004": "Responsabile del punto vendita",
    "0008": "Responsabile dei sistemi IT",
    "Z003": "Tecnico delle operazioni",
    "Z006": "Autres"
  },
  "ar": {
    "0028": "مستشار/مراقب إدارة",
    "0009": "المدير المالي",
    "Z002": "رئيس التكنولوجيا",
    "0023": "مدير العمليات",
    "0002": "مدير المشتريات",
    "0024": "مهندس/أخصائي العمليات",
    "0025": "خبير المشتريات",
    "0001": "الإدارة/مجلس الإدارة",
    "0013": "مدير الخدمة والدعم",
    "0010": "مدير التسويق",
    "Z005": "مدير الصيانة",
    "Z004": "مدير المتجر",
    "0008": "مدير أنظمة تقنية المعلومات",
    "Z003": "فني العمليات",
    "Z006": "أخرى"
  }
}
